var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h3',[_vm._v("Ano")]),_c('div',{staticClass:"container"},[_c('div',{staticClass:"anos"},[_vm._l((_vm.anos),function(ano){return _c('router-link',{key:ano,attrs:{"to":_vm.generateUrl(ano)}},[_vm._v(_vm._s(ano))])}),_c('router-link',{staticClass:"todos",attrs:{"to":_vm.generateUrl(null)}},[_vm._v("TODOS OS ANOS")])],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }